import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Shell from "./console/Shell";
import Homepage from "./pages/Homepage";
import AcceptInvite from "./pages/AcceptInvite";
import MemberLogin from "./pages/MemberLogin";
import OwnerDesk from "./desk/OwnerDesk";
import ResetPassword from "./pages/ResetPassword";
import "./console.css";
import "./desk/theme.css";
import "./public.css";   // v4 Part 2 — light everywhere; must land AFTER the desk's token file
import "./desk/desk.css";
import "./desk/deskv4.css";

// The staff console — Login until there is a session, then the nine-agent Shell. Lives behind /console
// so the public homepage can own the root. (/terms, /privacy, /sms-consent are served as raw static
// HTML by setupProxy.js — React never sees them.)
function Console() {
  const { session, booting } = useAuth();
  if (booting) return <div data-testid="auth-booting" className="auth-booting" />;
  return session ? <Shell /> : <Login />;
}

// The member owner desk (M6) — its OWN route, never shared with the staff console. Member sign-in
// until there is a session, then the owner desk. The two failure models (staff SMS+TOTP+break-glass
// vs member code-first+password) do not share a screen, handler or session shape (founder ruling §1).
function Desk() {
  const { session, booting } = useAuth();
  if (booting) return <div data-testid="auth-booting" className="auth-booting" />;
  return session ? <OwnerDesk /> : <MemberLogin />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/accept" element={<AuthProvider audience="owner"><AcceptInvite /></AuthProvider>} />
        <Route path="/invite/:token" element={<AuthProvider audience="owner"><AcceptInvite /></AuthProvider>} />
        {/* Owner password reset (brief 24 Sep) — the emailed link lands here; owner-scoped provider so a
            successful reset mints the owner session and lands straight in the desk. */}
        <Route path="/reset" element={<AuthProvider audience="owner"><ResetPassword /></AuthProvider>} />
        {/* R1 is invite-only (founder ruling 8 Sep §1): the open phone sign-up funnel is closed.
            Any stray /signup link lands on the invitation homepage, never an open form. */}
        <Route path="/signup" element={<Navigate to="/" replace />} />
        {/* Fix 2 — each surface gets its OWN audience-scoped provider so owner and staff sessions in one
            browser never share a session slot or a refresh coordinator (no cross-audience overwrite). */}
        <Route path="/desk/*" element={<AuthProvider audience="owner"><Desk /></AuthProvider>} />
        <Route path="/console/*" element={<AuthProvider audience="staff"><Console /></AuthProvider>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
